import { defineMessage } from 'react-intl';

/** Label for the schedule tolerance field. */
export const toleranceLabelMessage = defineMessage({
  id: 'audit.props.tolerance',
  defaultMessage: 'Tolerancia',
});

/** Explains how before/after tolerance minutes are formatted. */
export const toleranceHelpMessage = defineMessage({
  id: 'audit.props.tolerance.help',
  defaultMessage:
    'Los valores se expresan en minutos. El formato es: minutos antes / minutos después de la fecha y hora programada.',
});

/** Label for the match-vs-schedule time difference. */
export const diffLabelMessage = defineMessage({
  id: 'audit.schedulesList.mentions.diffLabel',
  defaultMessage: 'Diff',
});

/** Warning when the confirmation falls outside the allowed tolerance window. */
export const offToleranceMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.detailModal.offTolerance',
  defaultMessage: 'La confirmación de schedule está fuera de la tolerancia permitida',
});
